module.exports = __webpack_public_path__ + "img/catalogue.b3ad1375.png";